import { Box } from "@mui/material";
import styles from "./style.module.css";
import SkillsList from "./skills-list";
import { useSelector } from "react-redux";

function SkillsBar({ activeSkill, setActiveSkill }) {
  const skills = useSelector((state) => state.publicUser.skills);

  return (
    <Box
      className={styles.skills}
      sx={{
        justifyContent: skills.length < 3 ? "flex-start" : "space-between",
      }}
    >
      <SkillsList activeSkill={activeSkill} setActiveSkill={setActiveSkill} />
    </Box>
  );
}

export default SkillsBar;
